import { func } from 'prop-types';
import React, { PureComponent } from 'react';
import { View, Image } from 'react-native';

import { iconArrowDown } from '../../assets';
import { C } from '../../common';
import { Consumer } from '../../context';
import { Touchable } from '../../reactor/components';
import styles from './NextPage.style';

const { AMPLITUDE: { CLICK_TYPE, ON_CLICK } } = C;

const IMAGE_PROPS = { resizeMode: 'contain', source: iconArrowDown };

class NextPage extends PureComponent {
  static propTypes = {
    onPress: func.isRequired,
  };

  _onPress = ({ logEvent }) => {
    const { props: { onPress } } = this;

    logEvent(ON_CLICK, { type: CLICK_TYPE.ANCHOR, anchorPage: 1 });
    onPress(1);
  }

  render() {
    const { _onPress } = this;

    return (
      <Consumer>
        { ({ ...context }) => (
          <Touchable onPress={() => _onPress(context)}>
            <View>
              <Image {...IMAGE_PROPS} style={[styles.imageArrow, { opacity: 1 }]} />
              <Image {...IMAGE_PROPS} style={[styles.imageArrow, { opacity: 0.75 }]} />
              <Image {...IMAGE_PROPS} style={[styles.imageArrow, { opacity: 0.5 }]} />
              <Image {...IMAGE_PROPS} style={[styles.imageArrow, { opacity: 0.25 }]} />
            </View>
          </Touchable>
        )}
      </Consumer>
    );
  }
}

export default NextPage;
